import "./SetupAccount.less";

import React, { Component } from "react";
import { Link } from "react-router-dom";
import { translate } from "react-i18next";
import queryString from "query-string";
import StepWizard from "react-step-wizard";

import { InstitutionSelect } from "./InstitutionSelect/InstitutionSelect";
import { RoleSelect } from "./RoleSelect/RoleSelect";
import AccountForm from "./AccountForm/AccountForm";
import logo from "../../assets/images/plantyn_logo.svg";
import { CreateAccountContext } from "../../contexts/contexts";
import SuperdogInfo from "../WizardSteps/SuperdogInfo/SuperdogInfo";

import config from "../../config";
import $ from "jquery";

const STUDENT = "student"; // TODO: Import from RoleSelect.js

class SetupAccount extends Component {
	/**
	 * We must set some props to undefined when we go back to a previous state
	 * resultProps is meant to be an array with property keys,
	 * telling us which props must be set to undefined
	 */

	state = {
		role: undefined,
		school: undefined,
		institution: undefined,
		setRole: value => this.setState({ role: value }),
		setSchool: value => this.setState({ school: value }),
		setInstitution: value => this.setState({ institution: value })
	};

	render() {
		const t = this.props.t;

		const currentQuery = queryString.parse(window.location.search);
		const returnUrl = currentQuery.returnUrl;
		const query = queryString.stringify({ returnUrl });

		return (
			<CreateAccountContext.Provider value={this.state}>
				<h1>{t("setupAnAccount")}</h1>
				<StepWizard transitions={{}} onStepChange={() => this.nextClickHandler()}>
					<RoleSelect />
					<InstitutionSelect />
					<SuperdogInfo />
				</StepWizard>
				<img className="plantyn_logo" src={logo} alt="" />
			</CreateAccountContext.Provider>
		);
	}

	nextClickHandler() {
		const currentQuery = queryString.parse(this.props.location.search);
		const returnUrl = currentQuery.returnUrl;

		if (this.state.role && (this.state.role === STUDENT || this.state.institution)) {
			$.ajax({
				method: 'POST',
				url: `${config.identityServer.baseUrl}/Portal/Setup`,
				xhrFields: {
					'withCredentials': true
				},
				data: {
					clientId: currentQuery.clientId || config.identityServer.clientId,
					culture: config.language + "-BE",
					isStudent: this.state.role == STUDENT,
					region: this.state.school.id,
					gradeLevel: this.state.role == STUDENT ? undefined : this.state.institution.id,
					returnUrl: returnUrl
				},
				success: result => {
                	window.location = '/login';
				}
			})
			.fail(() => {
                window.location = '/login';
			});
		}
	}
}

const translateSetupAccount = translate("registration")(SetupAccount);
export { translateSetupAccount as SetupAccount, CreateAccountContext };



// WEBPACK FOOTER //
// ./src/components/CreateAccount/SetupAccount.js